import { ButtonFrame, CardSearch, PageBodyHeader, Table } from "../../component";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { generalObj, UrlTypes } from "../../constant/object_types";
import { useOutletContext, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { encryptEmail, fetchUserListByStoreId } from "../../action/generalFunc";

const AdminOrderStoreTracker = () => {
    const navigate = useNavigate();
    const [vendorList, setVendorList] = useState<generalObj[]>([]);
    const [storeName, setStoreName] = useState<string>("");
    const [searchText, setSearchText] = useState<string>("");

    const {setModalLoading}:{setModalLoading:Function} = useOutletContext();
    const account = useSelector((state:RootState) => state.account);
    const { date, supervisor_id, store_id } =useParams();
     
    useEffect(() => {
        if (!account || !account.isAuthenticated || !store_id || !date) return;
        (async () => {
            let param_obj = { order_tracker: date.replaceAll("_", "-") };
            
            let result = await fetchUserListByStoreId(account.token, store_id, "vendor", param_obj);
            if (result) {
                setVendorList(result.data.users);
                setStoreName(`${result.data.store_data.name} - ${result.data.store_data.organization}`)
            }else{
                window.history.back();
            }
            setModalLoading(false);
        })();
    }, [account, store_id, date, setModalLoading]);

    const onSearch = (val:string) => {
        setVendorList((prevVendorList) => {
            return (
                prevVendorList.filter((item) => {
                    if (item.username.includes(val) || item.mobile.includes(val) || item.email.includes(val) || (item.store && val.includes(`${item.store.length}`))) {
                        item.show = true;
                    }else {
                        item.show = false;
                    }
                    return item;
                })
            )
        })
        setSearchText(val);
    }

    // const processExport = (export_type:string) => {
    //     generateReport(export_type)
    // }

    // const generateReport = async (export_type:string) => {
    //     if (!export_type || !account || !account.isAuthenticated || !store_id) return;

    //     setModalLoading(true);
    //     let param = {
    //         type: export_type,
    //         user_type: "vendor",
    //         store: store_id
    //     };
        
    //     let result = await fetchUserListReport(account.token, param);
    //     if (result && typeof(result) === "object") {
    //         const aElement = document.createElement('a');
    //         aElement.setAttribute('download', `vendor_list.${result.data.type.split("/")[1]}`);
    //         const href = URL.createObjectURL(result.data);
    //         aElement.href = href;
    //         aElement.setAttribute('target', '_blank');
    //         aElement.click();
    //         URL.revokeObjectURL(href);
    //         toast("Report generated");
    //     }
    //     setModalLoading(false);
    // }
    const formatNumber = (value:number | string | undefined) => value === undefined || value === null ? "-" : Number(value).toLocaleString("en-US", {maximumFractionDigits: 2});

    const getTargetDate = () => {
        const [year, month] = (date || "").replaceAll("_", "-").split("-");
        return { year, month };
    }


    return (
        <>
            <PageBodyHeader title="Vendor List" desc="Manage vendors">
                <ButtonFrame btn_text="Back" btn_style={{padding:"8px 24px", borderRadius:"8px", border:"1px solid #808280",  backgroundColor:"#808280", color:"#FFF", fontSize:"14px", fontWeight:"600", letterSpacing:"-0.4px"}} onPress={() => window.history.back()} />
            </PageBodyHeader>

            <Table table_head={["Username", "Email", "Target", "Achieved", "Action"]} th_class="white" color={"#1159AB"} thColor={"#1159AB"}
            tableSearch={<CardSearch value={searchText} onTextChange={(evt) => onSearch(evt)} />}
            tableAction={<div style={{display:"flex", alignItems:"center", gap:"12px"}}>
                {/* <ExportData export_type={(val) => processExport(val)} /> */}
            </div>}
            headerStyle={{marginBottom: "44px"}}
            table_title={`Vendors target for ${storeName} on ${getTargetDate().month} ${getTargetDate().year}`}
            >
                <>
                    {vendorList.map((item, index) => (
                        (item.show || item.show === undefined) && (
                            <tr key={index}>
                                <td>
                                    {item.username}
                                </td>
                                <td>{encryptEmail(item.email)}</td>
                                <td>{item?.order_tracker.length > 0 ? formatNumber(item.order_tracker[0].target) : 0}</td>
                                <td>{item?.order_tracker.length > 0 ? formatNumber(item.order_tracker[0].achieved) : 0}</td>
                                <td><ButtonFrame btn_text="See Details" btn_style={{padding:"6px 12px", borderRadius:"4px", backgroundColor:"#00983A", color:"#FFF", fontSize:"12px", fontWeight:"600"}} onPress={() => navigate(`${UrlTypes.ADMIN_ORDER_TARGET_STORE_TRACKER_DETAIL}${date}/${supervisor_id}/${store_id}/${item.id}/`)} /></td>
                            </tr>
                        )
                    ))}
                </>
            </Table>
        </>
    )
}

export default AdminOrderStoreTracker;